module.exports = __webpack_public_path__ + "static/media/logo-sage-intacct.943f83df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-sage-intacct.png
// module id = 1307
// module chunks = 17